module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "for-authors"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("For Authors")]), _vm._v(" "), _c('b-nav-item-dropdown', {
    staticClass: "nav mobile-page-menu hidden-md-up mb-2",
    attrs: {
      "is-nav": "",
      "text": _vm.currentPage
    }
  }, [_c('b-dropdown-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'forAuthorsSubmissionGuidelines'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.currentPage = 'Submission Guidelines'
      }
    }
  }, [_vm._v("Submission Guidelines")])], 1), _vm._v(" "), _c('b-dropdown-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'forAuthorsStyleGuidelines'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.currentPage = 'Style Guidelines'
      }
    }
  }, [_vm._v("Style Guidelines")])], 1), _vm._v(" "), _c('b-dropdown-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'forAuthorsPolicies'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.currentPage = 'Policies'
      }
    }
  }, [_vm._v("Policies")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-menu hidden-sm-down"
  }, [_c('b-nav', {
    staticClass: "row tabs"
  }, [_c('b-nav-item', {
    attrs: {
      "to": {
        name: 'forAuthorsSubmissionGuidelines'
      }
    }
  }, [_vm._v("Submission Guidelines")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'forAuthorsStyleGuidelines'
      }
    }
  }, [_vm._v("Style Guidelines")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": {
        name: 'forAuthorsPolicies'
      }
    }
  }, [_vm._v("Policies")])], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7de763d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/for-authors/ForAuthorsPage.vue
// module id = 1455
// module chunks = 1